import { OAuthProviderSchema } from "./oauth-providers";
import { z } from "zod";
export const WorkspaceOAuthRequestSchema = z.object({
    id: z.string(),
    workspaceId: z.string(),
    provider: OAuthProviderSchema,
    userId: z.string(),
    createdAt: z.coerce.date(),
});
